
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaiairporttopunecabs() {



    const cardData =
    {
        keyword: 'Mumbai Airport to Pune Cab',
        heading: 'Skyline Cabs: Mumbai Airport to Pune Cab',
        headingDescription: 'Skyline Cabs provides reliable and convenient Mumbai Airport to Pune Cab services to ensure a smooth ride after your flight. Whether you are landing at the domestic or international terminal, our punctual drivers will be ready to pick you up and drive you safely to Pune. Enjoy spacious, air-conditioned cars, transparent pricing, and 24/7 availability. Skip the wait and book your Mumbai Airport to Pune cab with Skyline Cabs for a comfortable and stress-free transfer.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Mumbai to Pune Cab Service",
      "description": "Skyline Cabs offers a reliable and comfortable cab service from Mumbai to Pune. Our fleet includes sedans, Ertiga, and Innova vehicles, ensuring a smooth and affordable journey."
    },
    {
      "name": "Mumbai Airport Terminal 2 to Pune Cab",
      "description": "Book a cab from Mumbai Airport Terminal 2 to Pune with Skyline Cabs for a stress-free ride. Our professional drivers ensure timely pickups and drop-offs to your desired destination."
    },
    {
      "name": "Mumbai Airport to Pune Cab Fare",
      "description": "Skyline Cabs provides transparent and competitive pricing for your Mumbai Airport to Pune journey. The fare includes all applicable charges such as tolls and fuel."
    },
    {
      "name": "Pune to Mumbai Airport Cab Price",
      "description": "Skyline Cabs offers affordable and transparent pricing for your Pune to Mumbai Airport ride. We provide well-maintained vehicles and professional drivers for a comfortable journey."
    },
    {
      "name": "Mumbai International Airport to Pune Cab",
      "description": "Skyline Cabs provides premium cab services from Mumbai International Airport to Pune. Choose from a variety of vehicles, including luxury cars and spacious SUVs, to ensure a comfortable ride."
    },
    {
      "name": "Mumbai Airport Pune Taxi Service",
      "description": "Skyline Cabs offers reliable taxi services from Mumbai Airport to Pune. Our services are available 24/7, ensuring that you can book a taxi for your airport transfers anytime."
    },
    {
      "name": "Mumbai Airport to Pune Cab Charges",
      "description": "Our cab charges from Mumbai Airport to Pune are transparent and affordable. We include all charges such as tolls and fuel in the fare with no hidden costs."
    },
    {
      "name": "Mumbai Airport to Pune Cab Service",
      "description": "Skyline Cabs provides professional cab services from Mumbai Airport to Pune. We ensure timely pickups, clean vehicles, and experienced drivers for your comfort and safety."
    },
    {
      "name": "Mumbai Airport to Pune Car Hire",
      "description": "Skyline Cabs offers car hire services from Mumbai Airport to Pune. Choose from a variety of well-maintained vehicles including sedans, SUVs, and luxury cars for a comfortable ride."
    },
    {
      "name": "Mumbai Airport to Pune Innova",
      "description": "Rent an Innova for your journey from Mumbai Airport to Pune. Skyline Cabs offers comfortable and spacious vehicles, perfect for families and groups traveling to Pune."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Online Booking",
      "description": "Book your taxi from Mumbai Airport to Pune online with Skyline Cabs. Our user-friendly platform makes it easy to book a ride at your convenience with no hidden fees."
    },
    {
      "name": "Mumbai International Airport to Pune Cab Service",
      "description": "Skyline Cabs offers reliable and safe cab services from Mumbai International Airport to Pune. We provide well-maintained vehicles, including Innova, Ertiga, and sedans, with professional drivers."
    },
    {
      "name": "Mumbai Pune Airport Cab",
      "description": "Skyline Cabs offers airport cab services between Mumbai and Pune. Book a one-way or round trip cab to ensure timely travel with professional drivers and comfortable vehicles."
    },
    {
      "name": "Mumbai Airport to Pune Innova Crysta Cab",
      "description": "For a luxurious and comfortable ride, choose an Innova Crysta from Mumbai Airport to Pune. Skyline Cabs offers this premium vehicle for a smooth and enjoyable journey."
    },
    {
      "name": "Mumbai Airport to Pune Ertiga Cab",
      "description": "Skyline Cabs offers Ertiga cabs for your Mumbai Airport to Pune journey. This spacious vehicle is perfect for families or groups traveling together with ample legroom and comfort."
    },
    {
      "name": "Mumbai Airport Cab Service",
      "description": "Skyline Cabs provides 24/7 airport cab services at Mumbai Airport. Our well-maintained vehicles, including sedans and SUVs, ensure a safe and comfortable ride to your destination."
    },
    {
      "name": "Mumbai Airport Car Rental",
      "description": "Skyline Cabs offers car rental services from Mumbai Airport to any destination. Choose from a wide range of vehicles including sedans, SUVs, and luxury cars with professional drivers."
    },
    {
      "name": "Airport Taxi Mumbai",
      "description": "Skyline Cabs provides fast and reliable airport taxi services at Mumbai Airport. Whether you need a ride to Mumbai city or Pune, we ensure timely and comfortable transfers."
    },
    {
      "name": "Mumbai Airport Transfer",
      "description": "Skyline Cabs offers seamless airport transfer services at Mumbai Airport. Whether you are traveling to Pune or within Mumbai, we ensure safe, punctual, and comfortable rides."
    },
    {
      "name": "Mumbai Airport Taxi",
      "description": "Skyline Cabs provides affordable and reliable taxi services from Mumbai Airport to your destination. Book your ride online or via phone, and enjoy a smooth, hassle-free transfer."
    },
    {
      "name": "Mumbai Airport Taxi Booking",
      "description": "Book your Mumbai Airport taxi with Skyline Cabs for a reliable and comfortable transfer to Pune, Mumbai city, or nearby locations. Enjoy timely pick-ups and professional drivers."
    },
    {
      "name": "Mumbai Airport Cab Service",
      "description": "Skyline Cabs offers premium airport cab services at Mumbai Airport. Choose from a variety of vehicles for your transfer to Pune, Mumbai city, or any other destination."
    },
    {
      "name": "Mumbai Airport Outstation Taxi",
      "description": "Skyline Cabs offers outstation taxi services from Mumbai Airport to various destinations, including Pune. Book a comfortable ride with professional drivers for a safe journey."
    },
    {
      "name": "Mumbai Airport to Hinjewadi Taxi Fare",
      "description": "Skyline Cabs offers affordable and transparent fare options for taxis from Mumbai Airport to Hinjewadi. Our pricing covers all necessary charges, ensuring a hassle-free ride."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Cab Service", "Mumbai Airport Terminal 2 to Pune Cab"],
    ["Mumbai Airport to Pune Cab Fare", "Pune to Mumbai Airport Cab Price"],
    ["Mumbai International Airport to Pune Cab", "Mumbai Airport Pune Taxi Service"],
    ["Mumbai Airport to Pune Cab Charges", "Mumbai Airport to Pune Cab Service"],
    ["Mumbai Airport to Pune Car Hire", "Mumbai Airport to Pune Innova"],
    ["Mumbai Airport to Pune Taxi Online Booking", "Mumbai International Airport to Pune Cab Service"],
    ["Mumbai Pune Airport Cab", "Mumbai Airport to Pune Innova Crysta Cab"],
    ["Mumbai Airport to Pune Ertiga Cab", "Mumbai Airport Cab Service"],
    ["Mumbai Airport Car Rental", "Airport Taxi Mumbai"],
    ["Mumbai Airport Transfer", "Mumbai Airport Taxi"],
    ["Mumbai Airport Taxi Booking", "Mumbai Airport Cab Service"],
    ["Mumbai Airport Outstation Taxi", "Mumbai Airport to Hinjewadi Taxi Fare"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai Airport to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides reliable and punctual cab services from Mumbai Airport to Pune, ensuring that you reach your destination smoothly after a flight. Our professional drivers are well-versed in the route and always ensure timely pickups and drop-offs, whether it's for a business trip, vacation, or personal visit."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Relax in comfort as you travel from Mumbai Airport to Pune in our well-maintained, air-conditioned vehicles. With options ranging from sedans to SUVs and luxury cars, we offer ample space for both passengers and luggage, ensuring a comfortable ride for every traveler."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are highly experienced, well-trained, and courteous, making your ride from Mumbai Airport to Pune as smooth and pleasant as possible. They are familiar with the route, ensuring the quickest and safest journey, and are dedicated to providing exceptional service throughout your trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers affordable pricing with a clear and transparent fare structure. You’ll know the price upfront, with no hidden charges or surprises at the end of the trip, allowing you to budget for your Mumbai Airport to Pune ride with peace of mind."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Whether your flight lands early in the morning or late at night, Skyline Cabs is available 24/7 to accommodate your Mumbai Airport to Pune ride. You can rely on us for flexible and convenient booking, ensuring you have transportation at any time."
    },
    {
        "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
        "WhyChoosedescription": "Skyline Cabs offers a wide range of vehicles to suit your needs, from compact sedans for solo travelers to spacious SUVs for groups or families. We ensure that you travel in comfort and style, with vehicles that provide ample room for both passengers and luggage."
    },
    {
        "WhyChooseheading": "Easy Booking Process with Instant Confirmation",
        "WhyChoosedescription": "Booking your cab from Mumbai Airport to Pune is simple and quick. You can book online via our website or mobile app and receive instant confirmation, giving you peace of mind as you land and start your journey. Additionally, you can track your ride in real-time for added convenience."
    },
    {
        "WhyChooseheading": "Safe and Secure Journey",
        "WhyChoosedescription": "Safety is a top priority at Skyline Cabs. Our vehicles are GPS-equipped, and our drivers are background-verified to ensure a secure and reliable journey. You can rest easy knowing that you’re in safe hands as you travel from Mumbai Airport to Pune."
    }
]














    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Mumbai Airport to Pune with Skyline Cabs?',
            answer:
                'Booking your ride is simple! Just visit our website or use the mobile app. Select Mumbai Airport as your pickup point and Pune as your drop-off location. Choose the vehicle of your choice, confirm your details, and you’re all set!',
        },
        {
            id: 2,
            question: 'What types of cabs are available for Mumbai Airport to Pune travel?',
            answer:
                'Skyline Cabs offers a variety of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. You can choose the vehicle that best suits your comfort, budget, and group size.',
        },
        {
            id: 3,
            question: 'Are the fares fixed for Mumbai Airport to Pune cabs?',
            answer:
                'Yes, we offer fixed, upfront pricing. The fare includes tolls, taxes, and driver charges, with no hidden fees. You’ll know the total cost before confirming your booking.',
        },
        {
            id: 4,
            question: 'Can I book a round-trip cab from Mumbai Airport to Pune?',
            answer:
                'Yes, we provide both one-way and round-trip options. If you need a return trip, simply provide your return details when booking, and we will arrange the return journey from Pune to Mumbai Airport.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Mumbai Airport to Pune?',
            answer:
                'The journey typically takes around 3 to 4 hours depending on traffic. Our experienced drivers know the best routes to ensure you reach your destination safely and on time.',
        },
        {
            id: 6,
            question: 'Are your drivers experienced with airport transfers?',
            answer:
                'Yes, all of our drivers are experienced, background-verified, and well-versed with the airport and highway routes. They ensure a safe and comfortable journey for all passengers.',
        },
        {
            id: 7,
            question: 'Can I book a cab for a specific time for Mumbai Airport to Pune?',
            answer:
                'Yes, you can book your cab at any specific time you need. Whether it’s an early morning flight or a late-night arrival, we ensure timely pickup and comfortable travel.',
        },
        {
            id: 8,
            question: 'Are the cabs clean and well-maintained for Mumbai Airport to Pune travel?',
            answer:
                'Yes, all our cabs are thoroughly cleaned, sanitized, and maintained to provide you with the utmost comfort and safety during your journey.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my booking for Mumbai Airport to Pune?',
            answer:
                'Yes, we offer flexible cancellation and modification policies. You can modify or cancel your booking via our app, website, or by contacting our support team.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for Mumbai Airport to Pune?',
            answer:
                'Skyline Cabs offers reliable, timely, and comfortable service. With experienced drivers, a variety of vehicle options, and fixed pricing, we make your journey from Mumbai Airport to Pune seamless and stress-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rajesh Kumar",
            rating: 5,
            review: "I used Skyline Cabs for a pickup from Mumbai Airport to Pune. The driver was waiting for me at the airport on time, and the ride was smooth and comfortable. Excellent service — highly recommend for airport transfers!"
        },
        {
            name: "Miss. Shruti Deshmukh",
            rating: 4,
            review: "Great experience traveling from Mumbai Airport to Pune with Skyline Cabs. The car was clean, and the driver was professional. I had a peaceful journey after a long flight. Could improve with offering Wi-Fi in the car, but overall, great service!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/mumbai-airport-to-pune-cab.jpg",
  "description": "Book Mumbai Airport to Pune cabs with Skyline Cabs for safe, on-time, and hassle-free airport pickups. Choose from AC sedans or SUVs with 24/7 availability and experienced drivers for one-way or return trips.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8046"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1400",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-airport-to-pune-cabs"
  }
};



     
      


    return (
        <div>
<Helmet>
  <title>Mumbai Airport to Pune Cabs | 24x7 Pickup & Drop | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport to Pune cabs with Skyline Cabs for safe, on-time, and hassle-free airport pickups. Choose from AC sedans or SUVs with 24/7 availability and experienced drivers for one-way or return trips." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Airport to Pune Cabs, Cab from Mumbai Airport to Pune, Airport Taxi Mumbai to Pune, One-Way Airport Drop Mumbai to Pune, AC Cab Mumbai Airport to Pune, SUV Taxi Mumbai Airport to Pune, 24/7 Airport Pickup Mumbai Pune, Online Cab Booking Mumbai Airport to Pune, Skyline Cabs Airport to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/30.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairporttopunecabs;